import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap, Observable, of } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Paging } from '../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { Identity, IdentityListArray, IdentityListCount, IdentityListData } from '../../model/identity/identity';
import { DeviceAccount, DeviceAccountArray } from '../../model/identity/device-account';
import { CaptiveDeviceAccount, CaptiveDeviceAccountData } from '../../model/identity/captive-device-account';
import { PasspointDeviceAccount, PasspointDeviceAccountData } from '../../model/identity/passpoint-device-account';

@Injectable({
	providedIn: 'root'
})

export class IdentityMockService {
	private _url: string = `${environment.baseAPI}/identities`;

	constructor() { }

	GETIdentities(since: string, until: string, paging: Paging, mkt_consent?: boolean, prf_consent?: boolean, location_id?: string): Observable<Identity | any> {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"data": {
				"count": 226,
				"data": [
					{
						"id": "0194acabc243a9a92982a820ab21bf45b899981b50fb0cd44643c6f3e3326f2d",
						"verified": false,
						"email": "giuliaapopaa@icloud.com",
						"strategy": "event code",
						"first_name": null,
						"last_name": null,
						"phone_number": null,
						"last_update": 1732813323914,
						"registered_at": 1732813323914,
						"marketing_consent": true,
						"profile_consent": false,
					},
					{
						"id": "01dfdaa64218963695b12ad3222147e401195036696e2ed1f30f7381b8144d31",
						"verified": false,
						"email": "cmfkfjtjtt@gmail.com",
						"strategy": "email",
						"first_name": null,
						"last_name": null,
						"phone_number": null,
						"last_update": 1732791179402,
						"registered_at": 1732813323914,
						"marketing_consent": true,
						"profile_consent": false,
					},
					{
						"id": "01ea7e3e54a8912947ea9a5434b55ed3bd3fe2ee203ff92894cb1dab4abae5ce",
						"verified": false,
						"email": "pli85@hotmail.it",
						"strategy": "email",
						"first_name": null,
						"last_name": null,
						"phone_number": null,
						"last_update": 1732970674936,
						"registered_at": 1732813323914,
						"marketing_consent": true,
						"profile_consent": false,
					},
					{
						"id": "050d9996a72357fb6935f0447ae2fb5111d0b14e9c14beb84c761670c0645982",
						"verified": false,
						"email": "cloudemar@gmail.com",
						"strategy": "passpoint",
						"first_name": null,
						"last_name": null,
						"phone_number": null,
						"last_update": 1733231176503,
						"marketing_consent": true,
						"profile_consent": false,
					},
				]
			},
			"elapsed": 1388
		};
		return of(mockData);
	}

	GETDeviceAccounts(identity_id: string): Observable<DeviceAccount | any> {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"data": {
				"count": 226,
				"data": [
					{
						"username": "4d5e6f7a-8b9c-10d1-11e2-131415161718", // UUID
						"status": "active", // "active" o "inactive"
						"last_update": 1732813323914, // Timestamp
						"channel": "calendar", // "calendar" o "on the fly"
						"created_at": 1732791179402, // Timestamp
						"since": 1732651179402, // Timestamp di validità inizio
						"until": 1733231176503, // Timestamp di validità fine
						"os_version": "iOS 16", // Sistema operativo e versione
						"mac": "00:1A:2B:3C:4D:5E", // Indirizzo MAC
					},
					{
						"username": "a1b2c3d4-e5f6-7g8h-9i0j-1k2l3m4n5o6p",
						"status": "inactive",
						"last_update": 1732813323914,
						"channel": "on the fly",
						"created_at": 1732789602541,
						"since": 1732651179402,
						"until": 1733150780693,
						"os_version": "Android 17",
						"mac": "FF:EE:DD:CC:BB:AA",
					}
				],
			},

		};
		return of(mockData);
	}

	PUTDeviceUntil(profile_id: string, username: string) {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"data": {
				result: true,
			},
		};
		return of(mockData);
	}

	PUTDisableDevice(profile_id: string) {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"data": {
				result: true,
			},
		};
		return of(mockData);
	}

	GETDeviceAccountCaptiveService(identity_id: string, username: string): Observable<CaptiveDeviceAccountData | any> {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"elapsed": 123,
			"data": {
				"identity_email": "test@test.com",
				"username": "user1",
				"strategy": "CODE",
				"registration_location_id": "location id",
				"status": "DISABLED",
				"created_at": "2024-01-01T00:00:00Z",
				"last_login": "2024-03-01T00:00:00Z",
				"valid": null,
				"sponsor_email": null
			}
		}
		return of(mockData);
	}
	GETDeviceAccountPasspointService(identity_id: string, username: string): Observable<PasspointDeviceAccountData | any> {
		const mockData = {
			"success": true,
			"errorCode": 0,
			"errorMessage": null,
			"elapsed": 123,
			"data": {
				"identity_email": "test@test.com",
				"username": "user1",
				"status": "DISABLED",
				"created_at": "2024-01-01T00:00:00Z",
				"last_login": "2024-03-01T00:00:00Z",
				"valid_since": "2024-01-01T00:00:00Z",
				"valid_until": "2024-12-31T23:59:59Z",
				"os_version": "iOS 14.4",
				"channel": "MOBILE_APP",
				"passpoint_service": "test_service"
			}
		}
		return of(mockData);
	}
}